// @flow

import * as React from 'react';
import { Box, useSystem } from 'react-system';
import { useTheme } from '../../theme';

type Props = {|
  children: React.Node,
|};

export const LoginDivider = ({ children }: Props): React.Node => {
  const { text, colors, textColor, bgColor } = useTheme();
  const { px } = useSystem();

  return (
    <Box
      py={3}
      css={[
        text.button,
        textColor('mediumText'),
        {
          textAlign: 'center',
          position: 'relative',
          textTransform: 'uppercase',
          fontSize: '14px',
        },
      ]}
    >
      <Box
        css={{
          left: 0,
          position: 'absolute',
          top: '50%',
          width: '100%',
          borderBottom: `1px solid ${colors.divider}`,
        }}
      />
      <span
        css={[px(2), bgColor('white'), { position: 'relative', zIndex: 1 }]}
      >
        {children}
      </span>
    </Box>
  );
};
